import React, { Fragment } from 'react'
import { string, object, array, bool } from 'prop-types'
import classnames from 'classnames'
import { EMPTY_ARRAY } from '../../../utils/constants'
import Loader from '../../ui/loader/Loader'

const ContentView = ({ query, filteredData = EMPTY_ARRAY, renderFilter, renderNoMatchQuery, isOneColumn, isLoading }) => {
  if (isLoading) return <div className='ad-list__loader'><Loader /></div>

  return (
    <Fragment>
      <section className={classnames({
        'ad-filter__content': true,
        'ad-filter__content--one-column': isOneColumn
      })}>
        {query && filteredData.length === 0
          ? <div className='ad-filter__text'>{renderNoMatchQuery}</div>
          : renderFilter}
      </section>
    </Fragment>
  )
}

ContentView.propTypes = {
  query: string,
  filteredData: array,
  renderFilter: object,
  renderNoMatchQuery: object,
  isOneColumn: bool,
  isLoading: bool
}

export default ContentView